"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var viewportStyles = function viewportStyles(_ref) {
  var viewportHeight = _ref.viewportHeight,
      viewportAspectRatio = _ref.viewportAspectRatio,
      viewportBackgroundColor = _ref.viewportBackgroundColor,
      viewportShape = _ref.viewportShape;
  return (0, _emotion.css)({
    position: "relative",
    backgroundColor: viewportBackgroundColor,
    height: viewportHeight,
    paddingTop: viewportHeight ? undefined : "".concat(1 / viewportAspectRatio * 100, "%"),
    overflow: "hidden",
    borderRadius: viewportShape === "circle" ? "9999px" : undefined
  });
};

var styles = function styles(_ref2) {
  var src = _ref2.src,
      size = _ref2.size,
      viewportSpacingInset = _ref2.viewportSpacingInset;
  return (0, _emotion.css)({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundImage: "url(".concat(src, ")"),
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: size,
    margin: viewportSpacingInset
  });
};

var Image = function Image(props) {
  // HACK: The extra parent div is necessary to please the broken flex
  // implementation in older versions of Firefox. Otherwise we could have one
  // viewport div with the role and aria-label props applied to it.
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    role: "img",
    "aria-label": props.children
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _emotion.cx)(viewportStyles(props), props.className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(props)
  })));
};

Image.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The source of the image. Any value that would works with an HTML `img`
   * tag is acceptable.
   */
  src: _propTypes["default"].string.isRequired,

  /**
   * An accessible label for the image.
   */
  children: _propTypes["default"].string,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. These props will be passed
   * through to the underlying `div[role=img]` element. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 6.2.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Defines the size of the image in the viewport. Any value that would work
   * with the `background-size` CSS property is acceptable. If left blank the
   * image will display at its native size.
   */
  size: _propTypes["default"].string,

  /**
   * This fixes the aspect ratio of the viewport. For example `1` will create a
   * square viewport and `1.77` (`16/9`) will create a widescreen viewport.
   *
   * This is ignored if `viewportHeight` is provided.
   */
  viewportAspectRatio: _propTypes["default"].number,

  /**
   * This sets a background color that will be visible if the image does not
   * fill up the entire viewport.
   */
  viewportBackgroundColor: _propTypes["default"].string,

  /**
   * Set the height of the viewport using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * This overrides `viewportAspectRatio`.
   */
  viewportHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Define the shape of the viewport. The image and background color will be
   * clipped to this shape.
   */
  viewportShape: _propTypes["default"].oneOf(["rectangle", "circle"]),

  /**
   * Apply padding around the image using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  viewportSpacingInset: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
Image.defaultProps = {
  viewportShape: "rectangle",
  viewportAspectRatio: 16 / 9,
  viewportSpacingInset: 0
};
var _default = Image;
exports["default"] = _default;